export default __webpack_public_path__ + "static/media/button_youtube.b4cd9c51.svg";